<template>
<div>
  <card>
    <template slot="header">
      <h4 class="card-title">Manifest Information</h4>
    </template>
    <!-- <div class="row">
      <div class="col-md-6"> -->
        <el-form :inline="true" ref="form" :model="form" label-width="140px">
          <el-form-item label="MAWB">
            <el-input v-model="form.mawb" name="mawb" disabled></el-input>
            <span class="el-form-item__error">{{ errors.first('mawb') }}</span>
          </el-form-item>

          <el-form-item label="MAWB Date">
            <el-input v-model="form.mawbDate" name="mawbDate" disabled></el-input>
            <span class="el-form-item__error">{{ errors.first('mawbDate') }}</span>
          </el-form-item>

          <el-form-item label="HAWB">
            <el-input v-model="form.hawb" name="hawb" disabled></el-input>
            <span class="el-form-item__error">{{ errors.first('hawb') }}</span>
          </el-form-item>

          <el-form-item label="Bag No.">
            <el-input v-model="form.bagNo" name="bagNo"></el-input>
            <span class="el-form-item__error">{{ errors.first('bagNo') }}</span>
          </el-form-item>

          <el-form-item label="HS Code">
            <el-input v-model="form.hsCode" name="hsCode"></el-input>
            <span class="el-form-item__error">{{ errors.first('hsCode') }}</span>
          </el-form-item>

          <el-form-item label="Origin">
            <el-input v-model="form.origin" name="origin"></el-input>
            <span class="el-form-item__error">{{ errors.first('origin') }}</span>
          </el-form-item>

          <el-form-item label="Shipper Name">
            <el-input v-model="form.shipperName" name="shipperName" v-validate="'required'" clearable></el-input>
            <span class="el-form-item__error">{{ errors.first('shipperName') }}</span>
          </el-form-item>

          <el-form-item label="Shipper Address">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4}"
              placeholder="Shipper Address"
              v-model="form.shipperAddress">
            </el-input>
          </el-form-item>

          <el-form-item label="Shipper Tel">
            <el-input v-model="form.shipperTel" name="shipperTel" v-validate="'required'" clearable></el-input>
            <span class="el-form-item__error">{{ errors.first('shipperTel') }}</span>
          </el-form-item>

          <el-form-item label="Cnee Name">
            <el-input v-model="form.consigneeName" name="consigneeName" v-validate="'required'" clearable></el-input>
            <span class="el-form-item__error">{{ errors.first('consigneeName') }}</span>
          </el-form-item>

          <el-form-item label="Cnee Address">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4}"
              placeholder="Cnee Address"
              v-model="form.consigneeAddress">
            </el-input>
          </el-form-item>

          <el-form-item label="Cnee Province">
            <el-input v-model="form.consigneeProvince" name="consigneeProvince" v-validate="'required'" clearable></el-input>
            <span class="el-form-item__error">{{ errors.first('consigneeProvince') }}</span>
          </el-form-item>

          <el-form-item label="Cnee City">
            <el-input v-model="form.consigneeCity" name="consigneeCity" v-validate="'required'" clearable></el-input>
            <span class="el-form-item__error">{{ errors.first('consigneeCity') }}</span>
          </el-form-item>

          <el-form-item label="Cnee PostalCode">
            <el-input v-model="form.consigneePostalCode" name="consigneePostalCode" v-validate="'required'" clearable></el-input>
            <span class="el-form-item__error">{{ errors.first('consigneePostalCode') }}</span>
          </el-form-item>

          <el-form-item label="Cnee Tel">
            <el-input v-model="form.consigneeTel" name="consigneeTel" v-validate="'required'" clearable></el-input>
            <span class="el-form-item__error">{{ errors.first('consigneeTel') }}</span>
          </el-form-item>

          <el-form-item label="Weight">
            <el-input v-model="form.weight" name="weight" v-validate="'required'" clearable></el-input>
            <span class="el-form-item__error">{{ errors.first('weight') }}</span>
          </el-form-item>

          <el-form-item label="Weight Unit">
            <el-input v-model="form.weightUnit" name="weightUnit"></el-input>
            <span class="el-form-item__error">{{ errors.first('weightUnit') }}</span>
          </el-form-item>

          <el-form-item label="Package Unit">
            <el-input v-model="form.packageUnit" name="packageUnit"></el-input>
            <span class="el-form-item__error">{{ errors.first('packageUnit') }}</span>
          </el-form-item>

          <el-form-item label="QTY">
            <el-input v-model="form.qty" name="qty" v-validate="'required'" clearable></el-input>
            <span class="el-form-item__error">{{ errors.first('qty') }}</span>
          </el-form-item>

          <el-form-item label="Goods">
            <el-input v-model="form.goods" name="goods"></el-input>
            <span class="el-form-item__error">{{ errors.first('goods') }}</span>
          </el-form-item>

          <el-form-item label="Goods EN">
            <el-input v-model="form.goodsEN" name="goodsEN"></el-input>
            <span class="el-form-item__error">{{ errors.first('goodsEN') }}</span>
          </el-form-item>

          <el-form-item label="Currency">
            <el-input v-model="form.currency" name="currency" v-validate="'required'" clearable></el-input>
            <span class="el-form-item__error">{{ errors.first('currency') }}</span>
          </el-form-item>

          <el-form-item label="Total Price">
            <el-input v-model="form.totalPrice" name="totalPrice" v-validate="'required'" clearable></el-input>
            <span class="el-form-item__error">{{ errors.first('totalPrice') }}</span>
          </el-form-item>

          <el-form-item label="FOB">
            <el-input v-model="form.fob" name="fob"></el-input>
            <span class="el-form-item__error">{{ errors.first('fob') }}</span>
          </el-form-item>

          <el-form-item label="CIF">
            <el-input v-model="form.cif" name="cif"></el-input>
            <span class="el-form-item__error">{{ errors.first('cif') }}</span>
          </el-form-item>

          <el-form-item label="Exchange Rate">
            <el-input v-model="form.exchangeRate" name="exchangeRate"></el-input>
            <span class="el-form-item__error">{{ errors.first('exchangeRate') }}</span>
          </el-form-item>

          <el-form-item label="Duty Amount">
            <el-input v-model="form.dutyAmount" name="dutyAmount"></el-input>
            <span class="el-form-item__error">{{ errors.first('dutyAmount') }}</span>
          </el-form-item>

          <el-form-item label="Base VAT">
            <el-input v-model="form.baseVAT" name="baseVAT"></el-input>
            <span class="el-form-item__error">{{ errors.first('baseVAT') }}</span>
          </el-form-item>

          <el-form-item label="Vat">
            <el-input v-model="form.vat" name="vat"></el-input>
            <span class="el-form-item__error">{{ errors.first('vat') }}</span>
          </el-form-item>
<br>
<br>
          <el-form-item>
            <el-button @click="$router.push(`/customers`)">Back</el-button>
            <el-button type="warning" @click="onSubmit">Update</el-button>
            <el-button @click="getData">Reset</el-button>
          </el-form-item>
        </el-form>
      <!-- </div>
    </div> -->
    </card>
  </div>
</template>


<script>
import Vue from "vue"
import { Autocomplete } from "element-ui"
import { Card } from 'src/components/UIComponents'
import * as _apiManifest from "@/api/manifest"
import {
  Table,
  TableColumn,
  Select,
  Option,
  Tabs,
  TabPane,
  Button,
  Tooltip,
  Form,
  FormItem,
  Input,
  Checkbox,
  Notification,
  DatePicker,
  Tag,
  Scrollbar,
  Row,
  Col,
} from "element-ui"

Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(Option)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Button)
Vue.use(Tooltip)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(DatePicker)
Vue.use(Tag)
Vue.use(Scrollbar)
Vue.use(Row)
Vue.use(Col)

Vue.use(Autocomplete)

export default {
  components: {
    Card,
  },
  data() {
    return {
      inputSearch: '',
      form: {
        mawb: '',
        mawbDate: '',
        hawb: '',
        bagNo: '',
        hsCode: '',
        origin: '',
        shipperName: '',
        shipperAddress: '',
        shipperTel: '',
        consigneeName: '',
        consigneeAddress: '',
        consigneeProvince: '',
        consigneeCity: '',
        consigneePostalCode: '',
        consigneeTel: '',
        weight: '',
        weightUnit: '',
        packageUnit: '',
        qty: '',
        goods: '',
        goodsEN: '',
        currency: '',
        totalPrice: '',
        fob: '',
        cif: '',
        exchangeRate: '',
        dutyAmount: '',
        baseVAT: '',
        vat: '',
      },
      isSearchFound: true,
    }
  },
  watch: {
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      _apiManifest.get(this.$route.params.id)
        .then(response => {
          this.form = response.data
        })
        .catch(error => {
          this.$notify({
            message: error.response.data.message || 'Unsuccessfully',
            type: 'danger'
          })
        });
    },
    onSubmit () {
      this.$validator.validateAll().then((result) => {
        console.log(result)
        if (result) {
          this.update()
        } else {
          this.$notify({
          message: 'Please enter all required information',
            type: 'danger'
          })
        }
        //
      }).catch((e) => {
        this.$notify({
          message: e,
          type: 'danger'
        })
      })
    },
    update () {
      _apiManifest.update(this.form.id, this.form)
        .then(response => {
          this.$notify({
            message: 'Update Successfully',
            type: 'success'
          })
          this.getData()
        })
        .catch(error => {
          this.$notify({
            message: error.response.data.message || 'Unsuccessfully',
            type: 'danger'
          })
        });
    },
  }
}
</script>
